export default "__VITE_ASSET__DR911F0x__"